import Actions from '../action'
const initialState = {
    isLoading: false,
    foodProductDetails:[],
    error: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.FOOD_PRODUCT_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.FOOD_PRODUCT_LIST_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                foodProductDetails:action.data.response,
                error: false
            };
        }
        case Actions.FOOD_PRODUCT_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};
